import _extends from "@babel/runtime/helpers/esm/extends";
import { fieldsIBaseModelWithUser } from './base';
import { EModel } from './model';
export let EMessageRegistrationVendor;
(function (EMessageRegistrationVendor) {
  EMessageRegistrationVendor["TheCampaignRegistry"] = "the-campaign-registry";
  EMessageRegistrationVendor["Twilio"] = "twilio";
})(EMessageRegistrationVendor || (EMessageRegistrationVendor = {}));
export let EMessageRegistrationUseCase;
(function (EMessageRegistrationUseCase) {
  EMessageRegistrationUseCase["TwoFactorAuthentication"] = "two-factor-authentication";
  EMessageRegistrationUseCase["AccountNotifications"] = "account-notifications";
  EMessageRegistrationUseCase["CustomerCare"] = "customer-care";
  EMessageRegistrationUseCase["DeliveryNotifications"] = "delivery-notifications";
  EMessageRegistrationUseCase["FraudAlertMessaging"] = "fraud-alert-messaging";
  EMessageRegistrationUseCase["Marketing"] = "marketing";
  EMessageRegistrationUseCase["Mixed"] = "mixed";
  EMessageRegistrationUseCase["Polling"] = "polling-and-voting";
  EMessageRegistrationUseCase["PublicServiceAnnouncement"] = "public-service-announcement";
  EMessageRegistrationUseCase["SecurityAlert"] = "security-alert";
})(EMessageRegistrationUseCase || (EMessageRegistrationUseCase = {}));
export let EMessageRegistrationStatus;
(function (EMessageRegistrationStatus) {
  EMessageRegistrationStatus["Pending"] = "pending";
  EMessageRegistrationStatus["Success"] = "success";
  EMessageRegistrationStatus["Failure"] = "failure";
})(EMessageRegistrationStatus || (EMessageRegistrationStatus = {}));
export let EMessageRegistrationType;
(function (EMessageRegistrationType) {
  EMessageRegistrationType["None"] = "none";
  EMessageRegistrationType["ApplicationToPerson"] = "application-to-person";
  EMessageRegistrationType["VerifiedTollFree"] = "verified-toll-free";
  EMessageRegistrationType["EmergencyHighThroughput"] = "emergency-high-throughput";
  EMessageRegistrationType["Testing"] = "testing";
})(EMessageRegistrationType || (EMessageRegistrationType = {}));
export const fieldsMessageRegistration = _extends({}, fieldsIBaseModelWithUser, {
  externalId: {
    type: 'Object'
  },
  externalStatus: {
    type: 'Object'
  },
  form: {
    type: 'ID',
    ref: EModel.PatientForm
  },
  status: {
    type: 'Option',
    values: EMessageRegistrationStatus
  },
  type: {
    type: 'Option',
    values: EMessageRegistrationType
  },
  useCase: {
    type: 'Option',
    values: EMessageRegistrationUseCase
  },
  users: {
    type: 'ID',
    ref: EModel.User,
    array: true
  }
});